<mat-select [formControl]="skjemakontroll()" [compareWith]="erValgt" panelClass="velg-sakstype--alternativer" [placeholder]="placeholder()" class="e2e-sakstype" data-testid="sakstype" #sakstypevelger>
  <mat-select-tips>
    {{ "Sakstypen definerer hva som forventes av møtedeltagerne, samt hva som er målet med saken."|translate }}
  </mat-select-tips>
  @for (sakstype of sakstyper(); track sakstype.id) {
    <mat-option [value]="sakstype">{{ sakstype.navn }}</mat-option>
  }
  @if(visPausevalg()){
    <mat-option [value]="pausesak" class="mat-option--skillelinje-over"><span>{{ "Pause"|translate }}</span></mat-option>
  }
  <mat-option value="null" [ngClass]="{'mat-option--skillelinje-over':!visPausevalg()}"><span>{{ "ikke angitt"|translate }}</span></mat-option>
</mat-select>
